import React from 'react';
import { useLazyDecryptMyCreditCardQuery } from '../../services/creditCards';
import BaseDecryptCreditCardPopover from './BaseDecryptCreditCardPopover';
import { useDispatch } from 'react-redux';
import { apiSlice } from '../../app/api/apiSlice';

export default function UserDecryptCreditCardPopover({ creditCardId }) {
  const dispatch = useDispatch();
  
  function onDecryptError() {
    dispatch(apiSlice.util.invalidateTags(['MyCreditCards']));
  }
  
  return (
    <BaseDecryptCreditCardPopover
      creditCardId={creditCardId}
      useQueryHook={useLazyDecryptMyCreditCardQuery}
      tooltipText="View details for selected Credit Card"
      onDecryptError={onDecryptError}
    />
  );
}
